exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user_info[data-v-dd75817a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.user_info .ant-row.ant-form-item[data-v-dd75817a] {\n  width: 100%;\n  margin-right: 6px;\n}\n", ""]);

// exports
